import React, { useState } from 'react'
import { useField } from "formik";
import { number } from 'yup';

const formatter = new Intl.NumberFormat("en-IN", {
    // minimumFractionDigits: 0,
    // maximumFractionDigits: 2,
    useGrouping: true,
});

const AmountInput = ({ ...props }) => {
    const [field, meta, helpers] = useField(props);

    const handleChange = (e) => {
        console.log('e.target---', e.target.value)
        const rawValue = e.target.value.replace(/,/g, ""); // Remove commas
        console.log('rawValue---', rawValue)
        if (/^\d*\.?\d{0,2}$/.test(rawValue)) {
            helpers.setValue(rawValue)
        }
        if (props.setFieldChange) props.setFieldChange(rawValue)
    };

    const showAmountHandler = () => {
        if (!field.value) return ""
        const numberValue = field.value.toString()
        const valueArr = numberValue.includes('.') && numberValue.split('.')

        if (valueArr.length > 0) {
            const numberVal = formatter.format(valueArr[0])
            const decimalVal = valueArr[1]
            console.log('valueArr.length---', numberVal, decimalVal);
            return numberVal + '.' + decimalVal
        }
        // else {
        return formatter.format(numberValue)
        // }
    }

    return (
        <input
            {...field}
            {...props}
            type="text"
            value={field.value ? showAmountHandler() : ""}
            onChange={handleChange}
        />
    )
}

export default AmountInput